import { GridIcon } from '../../icons/GridIcon';
import { ListIcon } from '../../icons/ListIcon';
import { ToggleButton, ToggleWrapper } from './ViewToggle.styles';
import type { ViewToggleProps } from './ViewToggle.types';

export function ViewToggle({
  value,
  onChange,
  gridLabel = 'Grid view',
  compactLabel = 'Compact view',
}: ViewToggleProps) {
  return (
    <ToggleWrapper role="group">
      <ToggleButton
        type="button"
        $active={value === 'grid'}
        aria-label={gridLabel}
        aria-pressed={value === 'grid'}
        onClick={() => onChange('grid')}
      >
        <GridIcon />
      </ToggleButton>
      <ToggleButton
        type="button"
        $active={value === 'compact'}
        aria-label={compactLabel}
        aria-pressed={value === 'compact'}
        onClick={() => onChange('compact')}
      >
        <ListIcon />
      </ToggleButton>
    </ToggleWrapper>
  );
}
